export const CHECKOUT_CHANGE_STEP = 'CHECKOUT_CHANGE_STEP';
export const CHECKOUT_SELECTED_PAYMENT = 'CHECKOUT_SELECTED_PAYMENT';
